import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';

import PartsColor from '@/components/partsColor/PartsColor';

@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})

export default class File3 extends Vue {
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;

  product: ProductDefinition;

  seletedFoot: string = Ori3Foot.Boyali;

  defHideObjects = [
    '_yyy',
    'kolcak_plastik',
  ];

  defShowObjects =  [
    'file_3_yyy',
    'file_3_ayak_boyali_yyy',
  ];

  availableAnimations: AnimationDefinition[] = [];

  async created() {
    this.product = Store.getProductById('file3');
    this.product.partsPalettes = _.orderBy(this.product.partsPalettes,['order'],['asc']);
    this.availableAnimations =  this.product.animations as  AnimationDefinition[];
    this.availableAnimationsChanged();
    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });
    if (Store.state.selection) {
      Store.state.selection.parts.forEach((element) => {
        this.colorChanged(element.color,element.palette,element.id);
      });
      await this.changeFoot(Store.state.selection.foot);
    } else {
      await  this.applyDefaultSelection();
    }
  }

  availableAnimationsChanged()
  {
    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }

  mounted() {
    // this.configuratorService = Store.state.configuratorService;
  }

  async applyDefaultSelection() {
    const selection = new File3Selection();
    selection.parts = [];
    selection.foot = Ori3Foot.Boyali;
    this.product.defaults.parts.forEach((element) => {
      this.colorChanged(element.color,element.palette,element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.name = element.name;
      part.palette = element.palette;
      selection.parts.push(part);
    });

    Store.state.selection = selection;
  }

  async changeFoot(foot:Ori3Foot) {
    if (foot === Ori3Foot.Krom) {
      await this._configuratorService.hideObjects({ objects: ['file_3_ayak_boyali_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['file_3_ayak_metal_yyy'], operator: FilterOperators.Contains });
      Store.state.selection.foot = Ori3Foot.Krom;
      this.seletedFoot = Ori3Foot.Krom;
    }
    if (foot === Ori3Foot.Boyali) {
      await this._configuratorService.hideObjects({ objects: ['file_3_ayak_metal_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['file_3_ayak_boyali_yyy'], operator: FilterOperators.Contains });
      Store.state.selection.foot = Ori3Foot.Boyali;
      this.seletedFoot = Ori3Foot.Boyali;
    }
  }

  async colorChanged(color: any,palette: any,part: any) {
    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });

    if (part === 'backrest_3') {
      const op:string =  getColor.texture.split('.jpg')[0] + '_opacity.jpg';
      console.log(op);
      this._configuratorService.changeOpacity({
        materials: getPart.materials,
        texture: op,

      });
      await this._configuratorService.changeBumpMap({
        materials: getPart.materials,
        texture: op,
      });
    }
    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;
  }
}

export class File3Selection {
  parts: PartSelection[];
  foot:Ori3Foot ;
}
export class PartSelection {
  id: string;
  palette: string;
  name: string;
  color: string;
}
enum Ori3Foot {
  Krom = 'krom',
  Boyali = 'boyali',
}



// WEBPACK FOOTER //
// ./src/components/families/file/File3.ts